import z from "zod";
import { IChapter } from "./chapter";
import { serverTimestampSchema } from "./firestore";
import { generationStatusSchema } from "./generationStatus";
import { IReferenceDocument } from "./reference";

export enum ELanguage {
  ENGLISH_US = "English US",
  ENGLISH_UK = "English UK",
  GERMAN = "German",
}

export enum EBookType {
  NON_FICTION = "Narrative non-fiction",
}

export enum EGenre {
  FINANCE = "Business and finance",
  PERSONAL_DEVELOPMENT = "Personal development",
}

export const bookInputsSchema = z.object({
  title: z.string(),
  author: z.string(),
  language: z.nativeEnum(ELanguage),
  book_type: z.nativeEnum(EBookType),
  genre: z.nativeEnum(EGenre),
  thesis: z.string(),
  audience: z.string(),
  draft_toc: z.string(),
  author_bio: z.string().nullable().optional(),
  steering_instructions: z.string().nullable().optional(),
  copyright_agreement: z.boolean().optional(),
  topics: z.string().optional(),
  description: z.string().optional(),
  number_of_chapters: z.number().optional(),
  unique_selling_points: z.string().optional(),
});

export type IBookInputs = z.infer<typeof bookInputsSchema>;

export const bookDocumentSchema = z.object({
  userId: z.string(),
  book_inputs: bookInputsSchema,
  author_style_status: generationStatusSchema.nullable().optional(),
  author_style_prompt: z.string().nullable().optional(),
  author_style_content_hash: z.string().nullable().optional(),
  narrative_extraction_status: generationStatusSchema.nullable().optional(),
  narrative_extraction_error_code: z.string().nullable().optional(),
  book_deletion_status: generationStatusSchema.nullable().optional(),
  full_book_request_id: z.string().nullable().optional(),
  createdAt: serverTimestampSchema,
  updatedAt: serverTimestampSchema.optional(),
});

export interface IBook extends z.infer<typeof bookDocumentSchema> {
  id: string;
  parts?: IPart[];
  reference_documents?: IReferenceDocument[];
}

export const partDocumentSchema = z.object({
  number: z.number(),
  title: z.string(),
});

export interface IPart extends z.infer<typeof partDocumentSchema> {
  id: string;
  chapters: IChapter[];
}
